import { Injectable } from '@angular/core';
import { AccountService, DeviceService } from '@app/_services';
import { concat, pipe } from 'rxjs';
import { concatAll, first, map, switchMap, tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { User, Device } from '@app/_models';

@Injectable({
  providedIn: 'root'
})
export class DbService {

  constructor(
    private accountService: AccountService,
    private deviceService: DeviceService
  ) {

  }

  deleteDevice(sn: string) {
    return this.deviceService.delete(sn);
  }

}
